/* eslint-disable react/react-in-jsx-scope */
import { Typography, Box } from "@mui/material";
// import { tokens } from "../theme";

const Header = ({ title, subtitle }) => {
  // const theme = useTheme();
  // const colors = tokens(theme.palette.mode);
  return (
    <Box m="0px"
      textAlign="center"
      
    >
      <Typography
        // variant="h2"
        color='#f5f5f5'
        fontWeight="bold"
        sx={{ m: "0 0 0px 0",
              fontSize: { 
                      xs:'4vw',
                      sm: '2vw',
              }
         }}
      >
        {title}
      </Typography>
      <Typography color='#00e676'
        sx={{
          fontSize: { 
                      xs:'3vw',
                      sm: '1vw',
              }
         }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
